import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Avatar5 from '../../assets/img/avatar_5.svg';
import editIcon from '../../assets/img/icons/edit-pen.svg';
import createProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import ProjectListPopup from '../../components/ProjectListPopup/ProjectListPopup';
import Select from '../../components/ReactSelectDropdown';
import ToggleButtonComponent from '../../components/ToggleButton/ToggleButton';
import TaskActionTooltip from '../../components/Tooltip/TaskActionTooltip';
import {
  AssigneeMoreText,
  ColoredText,
  CommonFlex,
  CommonImage,
  CommonText,
  Container,
  ResendInvite,
  RoundLetterSection,
  StyledLink,
  TableText,
} from '../../styledComponents/common';
import {
  ToggleButton,
  ToggleButtonRound,
} from '../../styledComponents/invoice';
import {
  InviteHeadSection,
  InviteLink,
  InviteProjectSection,
  InviteTableContainer,
  MemberNameDiv,
  MembersTableContainer,
  MembersTableHeadContainer,
  RadioButton,
  TeamSection,
  UserSettings,
} from '../../styledComponents/members';
import { AssignedProjectBox, TableItem } from '../../styledComponents/teams';
import { RoundIcon } from '../Tasks/tasksStyles';
import {
  ApprovalSettingsSection,
  CommFirstRoundLetterComp,
  CommImageInviteComp,
  CommImageNameComp,
} from './CommonComponents';
import GuardModal from './GuardModal';
import SelfieWarningModal from './SelfieModal';
import UserTypeChangeWarningModal from './userTypeChangeWarningModal';

const MembersTable = props => {
  const { t } = useTranslation();
  const [isUserTypeChangeModalOpen, setIsUserTypeChangeModalOpen] =
    useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selfieModalOpen, setSelfieModalOpen] = useState(false);
  const [guardModalOpen, setGuardModalOpen] = useState(false);
  const [selectedGuardMember, setSelectedGuardMember] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [currentUserType, setCurrentUserType] = useState('');
  const [newUserType, setNewUserType] = useState('');

  const [role, setRole] = useState('');


  const handleApplyEmployeeTypeChange = () => {
    if (!selectedMember) return;

    // based on  roles of the user, we will update the employee type
    if (localStorage.getItem('user_role') === 'admin') {
      let payload = {
        update_type: "partial",
      }

      payload.user_updates = []
      payload.user_updates.push({
        user_id: selectedMember.id,
        fields: {
          user_type: selectedMember.user_type
        }
      })

      // Call the action with the payload
      setSelectedMember(null);
      setIsUserTypeChangeModalOpen(!isUserTypeChangeModalOpen);
      props.bulkUpdateEmployeeType(payload);
    }
    // else if (['gm', 'agm'].includes(localStorage.getItem('user_role'))) {
    //   const payload = [{
    //     user_id: selectedMember.id,
    //     first_name: selectedMember.first_name,
    //     last_name: selectedMember.last_name,
    //     email: selectedMember.email,
    //     role: selectedMember.role,
    //     office_id: selectedMember.office.id,
    //     user_type: selectedMember.user_type
    //   }]
    //   setSelectedMember(null);
    //   setIsUserTypeChangeModalOpen(!isUserTypeChangeModalOpen);
    //   props.requestUpdateEmployeeType(payload);
    // }
  };

  const [selectedMembers, setSelectedMembers] = useState([]);

  const onSelfieToggle = member => {
    setSelectedMember(member);
    setSelfieModalOpen(true);
  };

  const updateSelfiePermission = val => {
    props.UpdateSelfiePermission(selectedMember.id, val);
    setSelectedMember(null);
    setSelfieModalOpen(!selfieModalOpen);
  };

  const onGuardToggle = member => {
    setSelectedGuardMember(member);
    setGuardModalOpen(true);
  };

  const updateGuardPermission = val => {
    props.UpdateGuardPermission(selectedGuardMember.id, val);
    setSelectedGuardMember(null);
    setGuardModalOpen(!guardModalOpen);
  };

  const handleSelectMember = (member) => {
    setSelectedMembers(prev => {
      const isSelected = prev.some(item => item.id === member.id);

      const newSelection = isSelected
        ? prev.filter(item => item.id !== member.id)
        : [...prev, member];

      if (props.onSelectionChange) {
        props.onSelectionChange(newSelection);
      }

      return newSelection;
    });
  };

  const handleSelectAll = () => {
    let newSelection = [];

    if (!selectAll) {
      newSelection = [...props.membersList];
    }

    if (props.onSelectionChange) {
      props.onSelectionChange(newSelection);
    }

    setSelectedMembers(newSelection);
    setSelectAll(!selectAll);
  };

  const handleClearSelection = () => {
    setSelectedMembers([]);
    setSelectAll(false);

    if (props.onSelectionChange) {
      props.onSelectionChange([]);
    }
  };

  useEffect(() => {
    setRole(localStorage.getItem('user_role'));
  }, []);

  useEffect(() => {
    if (props.membersList && props.membersList.length > 0) {
      const allSelected =
        selectedMembers.length === props.membersList.length &&
        props.membersList.every(member =>
          selectedMembers.some(selected => selected.id === member.id)
        );

      setSelectAll(allSelected);
    }
  }, [selectedMembers, props.membersList]);

  const getMemberRoleAndRegion = (member) => {
    // if member role is agm then show agm with region else show role
    if (member.role === 'agm') {
      return <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <span>{member.role.toUpperCase()}</span>
        {/* tag with color */}
        {/* {member.region && <span style={{ backgroundColor: '#4d94fb', color: 'white', padding: '2px 5px', borderRadius: '5px' }}>{member.region}</span>} */}
      </div>
    }
    return member.role.toUpperCase();
  }



  return (
    <Container style={{ paddingBottom: `20px` }}>
      <UserTypeChangeWarningModal
        member={selectedMember}
        isOpen={isUserTypeChangeModalOpen}
        toggle={() => {
          setIsUserTypeChangeModalOpen(!isUserTypeChangeModalOpen);
        }}
        handleSave={handleApplyEmployeeTypeChange}
        isLoading={props.requestUpdateEmployeeTypeLoading}
        currentUserType={currentUserType}
        newUserType={newUserType}
      />

      <SelfieWarningModal
        member={selectedMember}
        isOpen={selfieModalOpen}
        toggle={() => {
          setSelfieModalOpen(!selfieModalOpen);
        }}
        handleSave={updateSelfiePermission}
        isLoading={false}
      />
      <GuardModal
        member={selectedGuardMember}
        isOpen={guardModalOpen}
        toggle={() => {
          setGuardModalOpen(!guardModalOpen);
        }}
        handleSave={updateGuardPermission}
        isLoading={false}
      />
      {props.isLoading ? (
        <ComponentCircleLoader />
      ) : (
        <>
          <MembersTableHeadContainer
            role={role}
            style={{ borderBottom: `1px solid #C2CCE1` }}
          >

            {role=== 'admin' && (
            <TableItem>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  style={{
                    cursor: 'pointer',
                    width: '22px',
                    height: '22px',
                    marginRight: '10px',
                    accentColor: '#313131',
                    borderRadius: '7px',
                    border: '1.5px solid #C2CCE1'
                  }}
                />
              </div>
            </TableItem>)}

            <TableItem>
              <TableText>{t('member_name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('user_id')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('email')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('role')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('contact_number')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('office')}</TableText>
            </TableItem>
            {(role === 'admin' || role === 'gm' || role === 'agm') &&
            !localStorage.getItem('viewer_role') ? (
              <TableItem>
                <TableText>{t('employee_type')}</TableText>
              </TableItem>
            ) : null}
            {role === 'admin' && !localStorage.getItem('viewer_role') ? (
              <TableItem>
                <TableText>{t('selfie')}</TableText>
              </TableItem>
            ) : null}
            {role === 'admin' && !localStorage.getItem('viewer_role') ? (
              <TableItem>
                <TableText>{t('guard')}</TableText>
              </TableItem>
            ) : null}
          </MembersTableHeadContainer>
          
          {props.membersList && props.membersList.length > 0 ? (
            props.membersList.map((member, index) => (
              <MembersTableContainer key={index} role={role}>
                {role === 'admin' && (
                <TableItem>
                  <input
                    type="checkbox"
                    checked={selectedMembers.some(item => item.id === member.id)}
                    onChange={() => handleSelectMember(member)}
                    style={{
                      cursor: 'pointer',
                      width: '22px',
                      height: '22px',
                      accentColor: '#313131',
                      borderRadius: '7px',
                      border: '1.5px solid #C2CCE1'
                    }}
                  />
                </TableItem>
                )}


                <TableItem>
                  <div
                  // onClick={() =>
                  //   props.history.push(
                  //     `/user/member-details?id=${member.id}`
                  //   )
                  // }
                  >
                    <CommImageNameComp
                      imgSource={member.avatar ? member.avatar : Avatar5}
                      name={`${member.first_name} ${member.last_name && member.last_name !=="null" ? member.last_name : ''}`.trim()}
                      size="36px"
                    />
                  </div>
                </TableItem>
                <TableItem>
                  <TableText>{member.user_code || `-`}</TableText>
                  {/* {member.mac_address ? (
                    <TableText fontWeight="500" color="#4d94fb">
                      {member.mac_address}
                    </TableText>
                  ) : null} */}
                </TableItem>
                <TableItem>
                  <TableText>{member.email || `-`}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{getMemberRoleAndRegion(member)}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{member.phone ? member.phone : `-`}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>
                    {member.office && member.office.id
                      ? member.office.name
                      : `-`}
                  </TableText>
                </TableItem>
                {
                (role === 'admin' ||
                  (role === 'gm' && member.role !== 'admin') ||
                  (role === 'agm' &&
                    (member.role === 'supervisor' ||
                      member.role === 'employee'))
                    
                ) 
                &&
                !localStorage.getItem('viewer_role') ? (
                  <TableItem>
                    <UserSettings>
                      <RadioButton
                        cursor="pointer"
                        onClick={() => {
                          if (member.user_type === 'remote') {
                            return;
                          }
                          if(role === 'admin') {
                          setSelectedMember({...member, user_type: 'remote'});
                          setCurrentUserType(member.user_type);
                          setNewUserType('remote');
                          setIsUserTypeChangeModalOpen(!isUserTypeChangeModalOpen);
                        }
                        }}
                        active={member.user_type === 'remote'}
                      />
                      <ColoredText
                        cursor="pointer"
                        type={member.user_type === 'remote' ? 'success' : undefined}
                        fontSize="13px"
                      >
                        {t('remote_user')}
                      </ColoredText>
                      <RadioButton
                        cursor="pointer"
                        onClick={() => {
                          if (member.user_type === 'office') {
                            return;
                          }
                          if(role === 'admin') {
                          setSelectedMember({...member, user_type: 'office'});
                          setCurrentUserType(member.user_type);
                          setNewUserType('office');
                          setIsUserTypeChangeModalOpen(!isUserTypeChangeModalOpen);
                          }
                        }}
                        active={member.user_type === 'office'}
                      />
                      <ColoredText
                        cursor="pointer"
                        type={member.user_type === 'office' ? 'success' : undefined}
                        fontSize="13px"
                      >
                        {t('office_user')}
                      </ColoredText>
                      <RadioButton
                        cursor="pointer"
                        onClick={() => {
                          if (member.user_type === 'mashaer') {
                            return;
                          }
                          if (role === 'admin') {
                          setSelectedMember({...member, user_type: 'mashaer'});
                          setCurrentUserType(member.user_type);
                          setNewUserType('mashaer');
                          setIsUserTypeChangeModalOpen(!isUserTypeChangeModalOpen);
                        }

                        }}
                        active={member.user_type === 'mashaer'}
                      />
                      <ColoredText
                        cursor="pointer"
                        type={member.user_type === 'mashaer' ? 'success' : undefined}
                        fontSize="13px"
                      >
                        {t('mashaer_user')}
                      </ColoredText>
                    </UserSettings>
                  </TableItem>
                ) : (
                  <></>
                )}
                {role === 'admin' && !localStorage.getItem('viewer_role') ? (
                  <TableItem>
                    <ToggleButtonComponent
                      active={member.clockin_selfie}
                      handleClick={() => onSelfieToggle(member)}
                    />
                  </TableItem>
                ) : null}
                {role === 'admin' && !localStorage.getItem('viewer_role') ? (
                  <TableItem>
                    {member.user_type === 'office' ? (
                      <ToggleButtonComponent
                        active={member.is_guard}
                        handleClick={() => onGuardToggle(member)}
                      />
                    ) : null}
                  </TableItem>
                ) : null}
                {role === 'admin' && !localStorage.getItem('viewer_role') && (
                  <TableItem>
                    <RoundIcon
                      type="edit"
                      onClick={() =>
                        props.history.push(
                          `/user/member-add-update?id=${member.id}`,
                        )
                      }
                    >
                      <CommonImage src={editIcon} alt="" size="16px" />
                      <TaskActionTooltip toolTipText={t('edit_member')} />
                    </RoundIcon>
                  </TableItem>
                )}
              </MembersTableContainer>
            ))
          ) : (
            <NoDataComponent
              title={t('no_members_found')}
              padding="5vh 0"
              imageHeight="140px"
            />
          )}
        </>
      )}
    </Container>
  );
};

export default MembersTable;
